import {
    bookingSubmissionAdditionalReasons,
    preventativeMaintenanceAdditionalReasons
} from './service-contract-additional-reason-enum';

export enum ServiceContractReason {
    BOOKING_SUBMISSION = 'BOOKING_SUBMISSION',
    CANCELLATION = 'CANCELLATION',
    COVERAGE_QUESTION = 'COVERAGE_QUESTION',
    PURCHASE_ORDER_SUBMISSION = 'PURCHASE_ORDER_SUBMISSION',
    CONTRACT_COPY_REQUEST = 'CONTRACT_COPY_REQUEST',
    PREVENTIVE_MAINTENANCE_ISSUE = 'PREVENTIVE_MAINTENANCE_ISSUE',
    NOTIFICATION_CLOSURE = 'NOTIFICATION_CLOSURE'
}

export const serviceContractSubtypeAdditionalReasonsMap = {
    [ServiceContractReason.BOOKING_SUBMISSION]: bookingSubmissionAdditionalReasons,
    [ServiceContractReason.PREVENTIVE_MAINTENANCE_ISSUE]: preventativeMaintenanceAdditionalReasons
};
